import { createStore } from 'vuex'
import { getApiBaseUrl } from '@/config/apiBaseUrl'

export default createStore({
  state: {
    appName: 'Admin',
    apiUrl: getApiBaseUrl(),
    defaultPerPage: 15
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
